export default __webpack_public_path__ + "static/media/video-on-green.a054df7c.svg";